export default "__VITE_ASSET__60fd4d1f__"